// extracted by mini-css-extract-plugin
export var divider = "_wd-0";